
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 5.197v5.363c0 1.347-1.002 2.44-2.238 2.44H2.238C1.002 13 0 11.907 0 10.56V2.44C0 1.093 1.002 0 2.238 0h2.998C5.934 0 6.5.617 6.5 1.378c.011.753.574 1.356 1.264 1.356h2.998c.597 0 1.17.26 1.59.723.42.462.653 1.089.648 1.74z","fill":"#585858"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.517 5.574L6.01 8.079a.7.7 0 00.104.973l1.889 1.889a.7.7 0 00.972.104l2.506-2.506a.555.555 0 00.154-.442l-.13-1.779a.86.86 0 00-.768-.768l-1.78-.13a.554.554 0 00-.441.154zm1.438 1.95a.41.41 0 01-.297-.127.41.41 0 010-.593.42.42 0 11.593.593.41.41 0 01-.296.128z","fill":"#fff"}})])
          )
        }
      }
    